<template>
    <div v-if="ticketDetail"  class="alert-ringraziamento-container text-start">
        <div class="alert alert-success" role="alert">
            <div style="margin-bottom: 10px;" v-html="messaggioRingraziamento"></div>
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "alertRingraziamento",
    mounted() {},
    props: {
     
        ticketDetail: {
            type: Object,
            default: null
        }
    },
    

    data: function () {
        return {
            intl: intl,
            
            
        };
    },
    methods: {
        
    },
    watch: {
        
        
    },
    computed: {
        messaggioRingraziamento:function(){
            if(this.ticketDetail.area == this.$store.state["libraryWiperConfig"].ufficioAmministrativoId){
                if(this.ticketDetail.active == 1){
                    if(this.ticketDetail.area == 6){
                        return this.intl[this.$store.state.lang]['html_ringraziamento_active-6']
                    }        
                    return this.intl[this.$store.state.lang]['html_ringraziamento_active']
                }else{
                    return this.intl[this.$store.state.lang]['html_ringraziamento'].replace("**mail**", this.ticketDetail?.email);
                }
            }else{
                return this.intl[this.$store.state.lang]['html_ringraziamento'].replace("**mail**", this.ticketDetail?.email);
            }

            
        },
    },
};
</script>
